export const buildMeta = {
  version: "0.1.0",
  commitMessage: "feat: a privacy policy, and delete your account whenever you like",
  commit: "72723fe",
  buildDate: "2026-11-03"
};
